import Container from 'react-bootstrap/Container';
import { CabecalhoInstitucional } from '../../components/CabecalhoInstitucional';
import { RodapeInstitucional } from '../../components/RodapeInstitucional';

export function PoliticaPrivacidade() {
  return (
    <div>
      <CabecalhoInstitucional />

      <Container as="main" style={{ maxWidth: '760px' }} className="py-4 pb-5" >
        <div style={{ lineHeight: 1.7 }}>
          <h1 style={{ fontSize: '28px' }}>Política de Privacidade</h1>
          <p style={{ fontSize: '13px', color: 'var(--cor-texto)' }}>Última atualização: julho de 2026</p>

          <p>
            Esta Política de Privacidade descreve como o <strong>Lizzi Food</strong> (CNPJ 58.030.824/0001-94) coleta,
            usa e protege os dados pessoais de quem utiliza nosso sistema de gestão para restaurantes.
          </p>

          <h2 style={{ fontSize: '19px' }}>1. Quais dados coletamos</h2>
          <p>
            Coletamos os dados que você nos fornece diretamente ao criar uma conta (nome, e-mail, celular e senha) e os
            dados operacionais que você cadastra para usar o sistema (cardápio, produtos, matérias-primas, pedidos,
            equipe e lançamentos financeiros do seu estabelecimento).
          </p>
          <p>
            Quando um cliente do seu restaurante faz um pedido pelo cardápio público (via QR Code), coletamos apenas a
            identificação informada (por exemplo, nome ou número da mesa) e os itens do pedido — não exigimos cadastro
            nem login desse cliente final.
          </p>

          <h2 style={{ fontSize: '19px' }}>2. Para que usamos seus dados</h2>
          <ul>
            <li>Viabilizar o funcionamento do sistema (login, cardápio, pedidos, estoque, financeiro e relatórios);</li>
            <li>Enviar e-mails transacionais, como confirmação de cadastro e redefinição de senha;</li>
            <li>Manter a segurança da conta e prevenir uso indevido da plataforma;</li>
            <li>Cumprir obrigações legais quando aplicável.</li>
          </ul>
          <p>Não vendemos nem compartilhamos seus dados com terceiros para fins de publicidade.</p>

          <h2 style={{ fontSize: '19px' }}>3. Isolamento entre estabelecimentos</h2>
          <p>
            O Lizzi Food é multi-tenant: os dados operacionais de cada estabelecimento (cardápio, pedidos, financeiro,
            equipe) ficam isolados e não são acessíveis por outros estabelecimentos cadastrados na plataforma.
          </p>

          <h2 style={{ fontSize: '19px' }}>4. Armazenamento e segurança</h2>
          <p>
            Suas senhas são armazenadas com hash criptográfico, nunca em texto puro. Adotamos medidas técnicas
            razoáveis para proteger os dados armazenados contra acesso não autorizado, perda ou alteração indevida.
          </p>

          <h2 style={{ fontSize: '19px' }}>5. Seus direitos</h2>
          <p>
            Nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você pode solicitar a qualquer momento a
            confirmação, correção, exclusão ou portabilidade dos seus dados pessoais, entrando em contato pelos canais
            abaixo.
          </p>

          <h2 style={{ fontSize: '19px' }}>6. Contato</h2>
          <p>
            Dúvidas sobre esta política podem ser enviadas pelo WhatsApp{' '}
            <a href="https://wa.me/5519998028779" target="_blank" rel="noreferrer" style={{ color: 'var(--cor-primaria)' }}>
              (19) 99802-8779
            </a>
            .
          </p>
        </div>
      </Container>

      <RodapeInstitucional />
    </div>
  );
}
